/* eslint-disable default-param-last */
import { EXTRATO_CONTA_SUCCESS, LIMPA_EXTRATO } from './constants';

const initialState = {
  done: false,
  ContaAdicional: { Contas: [{ Data: '', Item: '', Valor: '' }] },
  ContaIndividual: { Contas: [{ Data: '', Item: '', Valor: '' }] },
  ContaPatronal: { Contas: [{ Data: '', Item: '', Valor: '' }] },
  Saldo: 0,
  Rentabilidade: [
    {
      DataCompetencia: '',
      Percentual: '',
    },
  ],
  ultimaRentabilidade: {
    MesVigente: '',
    Percentual: '',
  },
  saudeFinanceira: {
    farol: '',
    percentualRetirada: 0,
    exaurimento: {},
  },
};

export default function extratoContaParticipante(state = initialState, action) {
  switch (action.type) {
    case EXTRATO_CONTA_SUCCESS:
      return {
        ...state,
        ...action.values,
        done: true,
      };
    case LIMPA_EXTRATO:
      return initialState;
    default:
      return state;
  }
}
